function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1f2617;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1534.834 -886.572)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M37.2,32.454c-4.708-.857-5.067-1.238-5.067-1.238,1.311-7.547-2.242-15.452-7.192-20.039C18.351,5.075,8.519,9.384.685.126c-1.825-2.16-.424,24.05,9.36,34.061,7.154,7.312,15.43,5.155,17.689,3.989A10.337,10.337,0,0,0,31.2,34.743a24.4,24.4,0,0,0,5.642,1.5C38.165,36.435,38.786,32.743,37.2,32.454Zm-8.314.686C21.812,30.7,15.6,24.755,11.567,20.1c-.332-.381.132-.939.49-.609a55.5,55.5,0,0,0,17.679,11.17A4,4,0,0,1,28.89,33.14Z",
  transform: "matrix(-0.276, 0.961, -0.961, -0.276, 1628.645, 897.431)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1534.834 896.638)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M39.108,35.309l-2,2.191-4.1-4.495,2-2.191,0,0a1.022,1.022,0,0,1,1.539,0l2.558,2.805,0,0a1.274,1.274,0,0,1,0,1.686m-7.273-1.019,4.109,4.492-12.1,13.257h-4.1V47.543ZM57.67,36.92,30.167,2.878,2.665,36.92h8.392V61.43H49.9V36.92Z",
  transform: "translate(-2.665 -2.878)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 30.736,
  height: 31.092,
  transform: "translate(11.828 21.972)"
})));

function SvgLogoWerbung(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logoWerbung",
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.811,
    height: 68.619,
    viewBox: "0 0 93.811 68.619",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWerbung);
export default __webpack_public_path__ + "static/media/logoWerbung.0d9865a6823e2b7dd2c840559d3264af.svg";
export { ForwardRef as ReactComponent };